import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api_url } from "../utils/auth";
import { toast } from "react-toastify";

const UpdateCandidate = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    enrollmentNo: "",
    category: "",
    aboutus: "",
  });

  const [files, setFiles] = useState({
    photo: null,
    barIdPhoto: null,
    coverLaterpdf: null,
  });

  // 🔹 Fetch candidate
  const fetchCandidate = async () => {
    const user = JSON.parse(localStorage.getItem("election_user"));
    if (!user || user.role !== "candidate") return;
    try {
      const res = await axios.get(
        `${api_url}/api/v1/election/candidate/${user._id}`,
      );
      setFormData(res.data);
    } catch {
      toast.error("Failed to load candidate");
    }
  };

  // 🔹 Fetch categories
  const fetchCategories = async () => {
    const res = await axios.get(
      `${api_url}/api/v1/superAdmin/get_all_election_category`,
    );
    setCategories(res.data);
  };

  useEffect(() => {
    fetchCandidate();
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  // 🔹 Submit update
  const handleSubmit = async (e) => {
    const user = JSON.parse(localStorage.getItem("election_user"));
    if (!user || user.role !== "candidate") return;
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key]) data.append(key, formData[key]);
      });

      Object.keys(files).forEach((key) => {
        if (files[key]) data.append(key, files[key]);
      });

      await axios.put(
        `${api_url}/api/v1/election/candidate/update/${user._id}`,
        data,
      );

      toast.success("Candidate updated successfully");
      navigate("/admin/candidates");
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className=" pt-4 ">
      <Row className="justify-content-center m-5">
        <Col md={8} lg={6}>
          <h3 className="mb-4 p-2" style={{ backgroundColor: "gray" }}>
            Update Candidate
          </h3>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Enrollment No</Form.Label>
              <Form.Control
                name="enrollmentNo"
                value={formData.enrollmentNo}
                onChange={handleChange}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              {/* <Form.Label>Category</Form.Label>
              <Form.Select
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="">Select category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </Form.Select> */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>About</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="aboutus"
                value={formData.aboutus}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Files */}
            <Form.Group className="mb-3">
              <Form.Label>Photo</Form.Label>
              <Form.Control
                type="file"
                name="photo"
                onChange={handleFileChange}
                accept="image/*"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Bar ID Photo</Form.Label>
              <Form.Control
                type="file"
                name="barIdPhoto"
                onChange={handleFileChange}
                accept="image/*"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Cover Letter PDF</Form.Label>
              <Form.Control
                type="file"
                name="coverLaterpdf"
                onChange={handleFileChange}
                accept="application/pdf"
              />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? <Spinner size="sm" /> : "Update Candidate"}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default UpdateCandidate;
